import { useEffect, useMemo, useState } from 'react';
import { playSound, Sound, stopSound } from '~/assets/sounds';
import { rage, useObservable } from '~/rage';
import { formatTime, Layouts } from '~/shared';
import { isAprilFoolsDay } from '~/utils/date';
import { TextLabel } from '../../components/TextLabel';
import { generateDeathMessage } from './DeathScreen.model';
import {
	StyledBottomContainer,
	StyledDeathContainer,
	StyledLine,
	StyledTimer,
	StyledTimerContainer,
	StyledWrapper,
} from './DeathScreen.styled';

const DeathScreen = () => {
	const deathSession = useObservable(rage.player.getDeathScreenSession());
	const [timeLeft, setTimeLeft] = useState(deathSession?.durationMs ?? 0);

	const deathMessage = useMemo(
		() => generateDeathMessage(deathSession?.killerNickname),
		[deathSession?.killerNickname],
	);

	useEffect(() => {
		setTimeLeft(deathSession?.durationMs ?? 0);
	}, [deathSession]);

	useEffect(() => {
		if (!isAprilFoolsDay()) return;

		// TODO: Sound.FunnySound2 для смерти в воде, когда появится причина смерти
		playSound(Sound.FunnySound);

		return () => stopSound(Sound.FunnySound);
	}, []);

	useEffect(() => {
		if (timeLeft <= 0) {
			return;
		}

		const timeout = setTimeout(
			() => setTimeLeft((timeLeft) => timeLeft - 1000),
			1000,
		);
		return () => clearTimeout(timeout);
	}, [timeLeft, deathSession?.sequenceId]);

	const timeString = useMemo(
		() => formatTime(Math.max(timeLeft, 0), '{mm}:{ss}'),
		[timeLeft],
	);

	return (
		<StyledWrapper className={Layouts.DeathScreen}>
			<StyledDeathContainer>
				<TextLabel
					style={{
						fontStyle: 'italic',
						fontWeight: 700,
						fontSize: 40,
						color: '#FFFFFF',
					}}
				>
					ВЫ УМИРАЕТЕ!
				</TextLabel>
				<StyledLine />
				<TextLabel
					style={{
						fontWeight: 300,
						fontSize: 16,
						fontStyle: 'italic',
						color: 'rgba(255, 255, 255, 0.5)',
						textAlign: 'center',
						marginTop: 27,
						maxWidth: 660,
					}}
				>
					{deathMessage}
				</TextLabel>
			</StyledDeathContainer>
			<StyledBottomContainer>
				<TextLabel style={{ fontSize: 16, color: '#FFFFFF', opacity: 0.25 }}>
					Вы очнетесь через
				</TextLabel>
				<StyledTimerContainer>
					<StyledTimer />
					<TextLabel
						style={{
							fontSize: 16,
							fontWeight: 500,
							color: '#fabe2c',
							width: 44,
						}}
					>
						{timeString}
					</TextLabel>
				</StyledTimerContainer>
			</StyledBottomContainer>
		</StyledWrapper>
	);
};

export { DeathScreen };
